module.exports = __webpack_public_path__ + "static/media/mediumredphoto.ff8fcf30.jpg";